import { Outlet, createFileRoute } from '@tanstack/react-router';

// Layout route for the Payments scaffold (Phase 8). The /admin parent route
// gates on the `admin` role server-side, so this subtree inherits that guard —
// no extra check here (matches admin.bi.tsx, admin.staff.tsx, and every other
// admin.* route).
export const Route = createFileRoute('/admin/payments')({
  component: PaymentsRoute,
});

function PaymentsRoute() {
  return <Outlet />;
}
